export default __webpack_public_path__ + "static/jetson_safety_background-974d63f3043f973ac23586796b4d2e12.png";